import React from "react";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import "./salt.css";
import Img1 from "./img1.png";
// import Img3 from "../home/img2.png";
import SingleRecipiePage from "../../components/singleRecipiePage/SingleRecipiePage";
import SingleRecipiePageRight from "../../components/singleRecipiePage/SingleRecipiePageRight";
import EcavowhiteComponent from "../../components/ecavowhiteComponent/EcavowhiteComponent";

const Salt = () => {
  return (
    <>
      <Navb />

      <div className="whiteComponentsingleEcavo saltbg1">
        <SingleRecipiePage
          currrentImg={Img1}
          heading="Nandi Himalayan Pink Rock Salt"
          text="Nandi Pink Himalayan crystal salt is sourced from salt mines situated 5,000 feet deep beneath the Himalayan Mountain Range. Undergoing immense pressure over millions of years, the salt extracted from these mines is claimed to surpass 99 percent purity. Often touted as the most beneficial and purest salt , Himalayan Pink salt boasts a myriad of nutritional properties, in addition to its culinary uses. It serves as a healthier alternative to processed salt, providing over 84 minerals and trace elements, such as calcium, magnesium, potassium, copper, and iron. This salt not only enhances the flavor of your food but also offers a wealth of nutritional benefits."
          headingcss="whiteHeading"
          pcss="whiteP"
          // link1="link"
          // link1Text="View Recipes"
          link2="https://ecavo.shop/products/pink-salt"
          linkClass="whiteButton"
          //   sideImg={Sideimg1}
        />
      </div>

      <Footer />
    </>
  );
};

export default Salt;
